import { useSelector } from "react-redux";
import Product from "./Product";

const Items = () => {
  const cart_lines = useSelector((state) => state.cart.data.cart_lines);
  const renderItem = () => {
    return cart_lines.map((ele, i) => (
      <Product
        key={`cart_item_${i}_${ele.product.image.url}`}
        data={ele}
      />
    ))
  }

  return (
    <section className="mb-5">
      {renderItem()}
    </section>
  )
}

export default Items